var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3 ma-5 pa-5 indigo darken-1 white--text rounded-tl-xl"},[_vm._v("Teste")]),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }